import { render, staticRenderFns } from "./DetalleTratamientosReembolsados.vue?vue&type=template&id=22dfac64&scoped=true"
import script from "./DetalleTratamientosReembolsados.vue?vue&type=script&lang=js"
export * from "./DetalleTratamientosReembolsados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfac64",
  null
  
)

export default component.exports